import { useMedia } from 'react-use';

import { mediumDesktopAndAbove } from '#src/style/mediaQuery.ts';

export const useIsMediumDesktopAndAbove = () => useMedia(mediumDesktopAndAbove);
